import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select"]
  static values = { settingUrl: String, lockVersion: Number }

  change() {
    const select = this.selectTarget
    const priority = select.value
    const previousValue = select.dataset.previousValue ?? ""

    select.disabled = true

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content || ""

    fetch(this.settingUrlValue, {
      method: "PATCH",
      headers: { "Content-Type": "application/json", "Accept": "application/json", "X-CSRF-Token": csrfToken },
      body: JSON.stringify({ team_playbook_setting: { priority: priority, lock_version: this.lockVersionValue } }),
    }).then((response) => {
      select.disabled = false
      if (response.ok) {
        select.dataset.previousValue = priority
        this.#flashSuccess(select)
      } else if (response.status === 409) {
        select.value = previousValue
        this.#showConflictModal()
      } else {
        select.value = previousValue
        console.error(`[TeamPlaybook] Failed to update priority: ${response.status}`)
      }
    }).catch((error) => {
      select.disabled = false
      select.value = previousValue
      console.error("[TeamPlaybook] Failed to update priority:", error)
    })
  }

  selectTargetConnected(select) {
    select.dataset.previousValue = select.value
  }

  #flashSuccess(select) {
    select.classList.add("priority-saved")
    setTimeout(() => select.classList.remove("priority-saved"), 1200)
  }

  #showConflictModal() {
    const modalEl = document.getElementById("priorityConflictModal")
    if (!modalEl) return
    bootstrap.Modal.getOrCreateInstance(modalEl).show()
  }
}
